import { render, staticRenderFns } from "./MCheckbox.vue?vue&type=template&id=9bc8ecc4&scoped=true"
import script from "./MCheckbox.vue?vue&type=script&lang=js"
export * from "./MCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc8ecc4",
  null
  
)

export default component.exports